export const Video = ({ videoId="M7lc1UVf-VE", width="100%", height="100%" }) => {
    return <iframe 
    width={width} height={height}
    style={{position: 'absolute', top: 0, left: 0}}
    src={`https://www.youtube.com/embed/${videoId}`} 
    title="YouTube video player" 
    frameBorder="0" 
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
    allowFullScreen></iframe>
}